import firebase from 'firebase';
import { FIREBASE_API_KEY } from './secrets';

const config = {
    apiKey: FIREBASE_API_KEY,
    authDomain: "fpapp-106ec.firebaseapp.com",
    databaseURL: "https://fpapp-106ec.firebaseio.com",
    projectId: "fpapp-106ec",
    storageBucket: "fpapp-106ec.appspot.com",
    messagingSenderId: "800790830369"
};

firebase.initializeApp(config);
export const provider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();
export const storageRef = firebase.storage().ref();
export const db = firebase.firestore();
export default firebase;